// extracted by mini-css-extract-plugin
export default {"virtualCardPreview":"styles_virtualCardPreview__dwd0S"};